/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
import constantName from "./key"

export function loadRecords(id) {
  let payload = { status: "active", id: id }
  return api
    .post(`/get_all_lead`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function loadRecord(id) {
  return api
    .get(`/get_${atob(constantName)}_by_id?${atob(constantName)}Id=${id}`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export function loadClientRecord() {
  return api
    .get(`/get_all_${atob(constantName)}_profile`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadRecordClientDetails(id) {
  let payload = { status: "active", leadId: id }
  console.log(payload)
  return api
    .post(`/get_all_lead_${atob(constantName)}_detail`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function loadRecordClientProfileById(client) {
  
  return api
    .post(`/get_all_lead_by_${atob(constantName)}`, client)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {object} record
 * @returns
 */

export async function createRecord(record, profileData) {
  console.log("inside api call------------", profileData)
  try {
    const response = await api.post(
      `/add_lead_${atob(constantName)}_detail`,
      record,
      profileData
    )
    console.log(response.data, "response data from api call")
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 *
 * @param {object} record
 * @returns
 */

export function updateClientProfileRecord(record) {
  console.log("inside api call------------")
  try {
    const response = api.put(`/update_${atob(constantName)}_by_lead_id`, record)
    console.log(response.data, "response data from api call")
    return response.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 *
 * @param {object} record
 * @returns
 */
export function updateRecord(record) {
  return api
    .put(`/update_${atob(constantName)}_by_lead_id`, record)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      Promise.reject(error)
    })
}
export async function updateClientRecord(profileData) {
  try {
    console.log("Updated Api data ---> ")

    const response = await api.put(
      `/update_lead_${atob(constantName)}_detail_by_id`,
      profileData
    )
    console.log(response.data, "response updated data")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
export async function deleteClientRecord(clientRemoveId) {
  console.log(clientRemoveId, "remote for delete client")
  return api
    .delete(
      `/delete_lead_${atob(constantName)}_detail_by_id?leadClientDetailId=` +
        clientRemoveId
      // [`leadClientDetailId`]: [clientRemoveId]
    )
    .catch((error) => Promise.reject(error))
  // try {
  //   console.log("Deleted Api data ---> ")

  //   const response = await api.delete(
  //     `/delete_lead_${atob(constantName)}_detail_by_id`,
  //     {
  //       [`lead${atob(constantName)}DetailId`]: [id],
  //       status: 3,
  //     }
  //   )
  // } catch (error) {
  //   return Promise.reject(error)
  // }
}

/**
 *
 * @param {object} record
 * @returns
 */
export function updateClientStatus(record, profileData) {
  return api
    .put(`/delete_lead_${atob(constantName)}_detail_by_id`, record, profileData)
    .catch((error) => Promise.reject(error))
}
/**
 *
 * @param {integer} id
 * @returns
 */
export function deleteRecord(id) {
  return api
    .put(`/delete_${atob(constantName)}_by_id`, {
      [`${atob(constantName)}Id`]: [id],
      status: 3,
    })
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {object} record
 * @returns
 */
export function updateStatus(record) {
  return api
    .put(`/delete_${atob(constantName)}_by_id`, record)
    .catch((error) => Promise.reject(error))
}

//Questions details
export function loadClientQuestionDetails() {
  let payload = { status: "active", module: "sales" }
  return api
    .post(`/get_all_question_list`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {object} record
 * @returns
 */
export async function createClientQuestionDetails(questionsList) {
  try {
    const response = await api.post(
      `/add_client_question_answer`,
      questionsList
    )
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export function loadClientDetailsQuestions(id) {
  let payload = { clientId: id }
  return api
    .post(`/get_client_question_answer`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {object} record
 * @returns
 */
export function leadStatus(record) {
  return api
    .post(`/add_lead_assign`, record)
    .catch((error) => Promise.reject(error))
}

//New lead creation
export async function createNewLeadDetails(newLead) {
  try {
    const response = await api.post(
      `/add_new_lead_by_manage_lead`,
      newLead
    )
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}
export function clientCompleteApi(client_complete) {
  return api
    .post(`/update_deliverable_client_complete`,client_complete)
    .catch((error) => Promise.reject(error))
}

export function clientAppearanceApi(clientAppearance_details) {
  return api
    .post(`/update_client_rating`,clientAppearance_details)
    .catch((error) => Promise.reject(error))
}

export  function updateClientTypeAPI(clientType) {
  return  api
    .post(`/update_lead_quotation_range`,clientType)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}


export  function updateEngagementAPI(clientType) {
  return  api
    .post(`/update_only_engagement`,clientType)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}


export  function updateHighGoodAPI(clientType) {
  return  api
    .post(`/update_client_appearance`,clientType)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
const remotes = {
  loadRecords,
  loadRecordsMetaData,
  loadRecord,
  loadClientRecord,
  loadRecordClientDetails,
  loadRecordClientProfileById,
  createRecord,
  updateClientProfileRecord,
  updateClientRecord,
  updateClientStatus,
  deleteClientRecord,
  updateRecord,
  deleteRecord,
  updateStatus,
  leadStatus,

  //Client questions list
  loadClientQuestionDetails,
  createClientQuestionDetails,
  loadClientDetailsQuestions,

  createNewLeadDetails,
  clientCompleteApi,
  clientAppearanceApi,
  updateClientTypeAPI,
  updateEngagementAPI,
  updateHighGoodAPI
}

export default remotes
